import { render } from "./DatabaseShopItemCard.vue?vue&type=template&id=2ef0cd34&scoped=true&ts=true"
import script from "./DatabaseShopItemCard.vue?vue&type=script&lang=ts"
export * from "./DatabaseShopItemCard.vue?vue&type=script&lang=ts"

import "./DatabaseShopItemCard.vue?vue&type=style&index=0&id=2ef0cd34&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef0cd34"]])

export default __exports__